import { toAbsoluteUrl } from '../../_metronic/helpers';

export const LogoImage = () => (
  <img alt='AHAD' className='h-25px logo' src={toAbsoluteUrl('/media/logos/AHAD-logo.png')} />
);
